export const formatDateForSearchTree = (date) => date
    .toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
})
    .replace(/ /g, '-');
export const formatTimeForSearchTree = (date) => date
    .toLocaleTimeString('en-GB', {
    hour12: false,
})
    .replace(/(:\d{2}| [AP]M)$/, '');
export const formatDateTimeForSearchTree = (date) => `${formatDateForSearchTree(date)} ${formatTimeForSearchTree(date)}`;
//# sourceMappingURL=formatDateForSearchTree.js.map